import { createContext, useState } from "react";
import "moment/locale/pt-br";

const ConfigurationContext = createContext();

const ConfigurationContextProvider = ({ children }) => {
  const [configuration, setConfiguration] = useState(null);

  return (
    <ConfigurationContext.Provider
      value={{
        configuration,
        setConfiguration,
      }}
    >
      {children}
    </ConfigurationContext.Provider>
  );
};

export { ConfigurationContext, ConfigurationContextProvider };
